.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1.5px solid transparent;
  border-radius: var(--radius-md);
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.15s var(--ease), border-color 0.15s var(--ease), color 0.15s var(--ease), transform 0.1s;
}
.btn:active:not(:disabled) {
  transform: translateY(1px);
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn:focus-visible {
  box-shadow: 0 0 0 3px var(--color-focus);
  border-radius: var(--radius-md);
}
.sm {
  height: var(--control-h-sm);
  padding-inline: 12px;
  font-size: var(--text-sm);
  border-radius: var(--radius-sm);
}
.md {
  height: var(--control-h-md);
  padding-inline: 18px;
  font-size: 0.9375rem;
}
.lg {
  height: var(--control-h-lg);
  padding-inline: 24px;
  font-size: var(--text-md);
  border-radius: var(--radius-lg);
}
.primary {
  background: var(--color-accent);
  color: var(--color-accent-contrast);
}
.primary:hover:not(:disabled) {
  background: var(--color-accent-hover);
}
.secondary {
  background: var(--color-surface);
  color: var(--color-text);
  border-color: var(--color-border-strong);
}
.secondary:hover:not(:disabled) {
  background: var(--color-surface-2);
  border-color: var(--color-text-subtle);
}
.ghost {
  background: transparent;
  color: var(--color-text);
}
.ghost:hover:not(:disabled) {
  background: var(--color-neutral-soft);
}
.danger {
  background: var(--color-danger-solid);
  color: #fff;
}
.danger:hover:not(:disabled) {
  filter: brightness(0.92);
}
.full {
  width: 100%;
}
.spinner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-inline-end-color: transparent;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
